import React, { useState, useEffect } from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import dbData from "../data/db.json";

const WHATSAPP_NUMBER = "447123456789";

export default function FlightHotelSearch() {
  const [search, setSearch] = useState({
    from: "LON",
    to: "",
    depart: "",
    return: "",
    guests: "2"
  });
  
  const [flightResults, setFlightResults] = useState([]);
  const [hotelResults, setHotelResults] = useState([]);
  const [page, setPage] = useState(1);
  const [sortBy, setSortBy] = useState("price");
  const [minRating, setMinRating] = useState(0);

  const RESULTS_PER_PAGE = 5;

  const airports = [
    { code: "LON", name: "London" },
    { code: "IST", name: "Istanbul" },
    { code: "AGP", name: "Malaga" },
    { code: "DUB", name: "Dublin" },
    { code: "BCN", name: "Barcelona" },
    { code: "JFK", name: "New York" }
  ];

  const getCityName = (code) => {
    const found = airports.find(a => a.code === code);
    return found ? found.name : code;
  };

  const handleSearch = (e) => {
    e.preventDefault();
    
    // Filter flights from local JSON
    let foundFlights = dbData.flights.filter(f =>
      (!search.from || f.origin === search.from) &&
      (!search.to || f.destination === search.to) &&
      (!search.depart || f.departureDate === search.depart) &&
      (!search.return || f.returnDate === search.return)
    );

    if (sortBy === "price") foundFlights = foundFlights.sort((a, b) => a.price - b.price);
    if (sortBy === "airline") foundFlights = foundFlights.sort((a, b) => a.airline.localeCompare(b.airline));

    setFlightResults(foundFlights);

    // Filter hotels from local JSON
    let foundHotels = dbData.hotels.filter(h =>
      (!search.to || h.destination.toLowerCase() === getCityName(search.to).toLowerCase()) &&
      h.rating >= minRating
    );
    
    foundHotels = foundHotels.sort((a, b) => 
      sortBy === "price" ? a.pricePerNight - b.pricePerNight : b.rating - a.rating
    );

    setHotelResults(foundHotels);
    setPage(1);
  };

  const pagedFlights = flightResults.slice((page - 1) * RESULTS_PER_PAGE, page * RESULTS_PER_PAGE);
  const pagedHotels = hotelResults.slice((page - 1) * RESULTS_PER_PAGE, page * RESULTS_PER_PAGE);

  const handleWhatsApp = (type, item) => {
    const msg = type === 'flight' 
      ? `Hi! I'd like to book:\n\nFlight: ${item.origin} → ${item.destination}\n${item.airline} ${item.flightNumber}\nPrice: £${item.price}\n\nPlease help me book!`
      : `Hi! I'd like to book:\n\nHotel: ${item.name}\n${item.destination}\nPrice: £${item.pricePerNight}/night\n\nPlease help me book!`;
    window.open(`https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(msg)}`);
  };

  return (
    <>
      <Navbar />
      <div style={{ padding: 30, maxWidth: 1200, margin: "0 auto" }}>
        
        <h1 style={{ fontSize: 32, fontWeight: 800, marginBottom: 10, color: "#124" }}>
          ✈️ Search Flights & Hotels
        </h1>
        <p style={{ fontSize: 16, color: "#666", marginBottom: 30 }}>
          Find your perfect holiday package
        </p>

        {/* Search Form */}
        <form onSubmit={handleSearch} style={{
          display: "flex", gap: 15, marginBottom: 35, alignItems: "center", flexWrap: "wrap",
          background: "#f5f7fa", padding: 20, borderRadius: 12
        }}>
          <select value={search.from} onChange={e => setSearch({ ...search, from: e.target.value })}
            style={{ padding: 10, borderRadius: 6, border: "1px solid #ddd" }}>
            {airports.map(a => <option key={a.code} value={a.code}>{a.name}</option>)}
          </select>
          
          <select value={search.to} onChange={e => setSearch({ ...search, to: e.target.value })}
            style={{ padding: 10, borderRadius: 6, border: "1px solid #ddd" }}>
            <option value="">Any Destination</option>
            {airports.filter(a => a.code !== search.from).map(a => 
              <option key={a.code} value={a.code}>{a.name}</option>
            )}
          </select>
          
          <input type="date" value={search.depart}
            onChange={e => setSearch({ ...search, depart: e.target.value })}
            style={{ padding: 10, borderRadius: 6, border: "1px solid #ddd" }} />
          
          <input type="date" value={search.return}
            onChange={e => setSearch({ ...search, return: e.target.value })}
            style={{ padding: 10, borderRadius: 6, border: "1px solid #ddd" }} />
          
          <select value={search.guests} onChange={e => setSearch({ ...search, guests: e.target.value })}
            style={{ padding: 10, borderRadius: 6, border: "1px solid #ddd" }}>
            {["1", "2", "3", "4"].map(n => <option key={n} value={n}>{n} Guests</option>)}
          </select>
          
          <button type="submit" style={{
            padding: "10px 30px", borderRadius: 7, background: "#4282ff", color: "#fff",
            fontWeight: 600, border: "none", cursor: "pointer"
          }}>
            Search
          </button>
          
          <select value={sortBy} onChange={e => setSortBy(e.target.value)}
            style={{ padding: 10, borderRadius: 6, border: "1px solid #ddd" }}>
            <option value="price">Sort: Lowest Price</option>
            <option value="airline">Sort: Airline A-Z</option>
          </select>
          
          <select value={minRating} onChange={e => setMinRating(Number(e.target.value))}
            style={{ padding: 10, borderRadius: 6, border: "1px solid #ddd" }}>
            <option value={0}>All Ratings</option>
            <option value={4.0}>4.0+ stars</option>
            <option value={4.5}>4.5+ stars</option>
          </select>
        </form>

        {/* Pagination */}
        <div style={{ display: "flex", gap: 10, marginBottom: 18 }}>
          <button 
            disabled={page <= 1}
            onClick={() => setPage(p => Math.max(1, p - 1))}
            style={{ padding: "5px 15px", borderRadius: 6, cursor: page <= 1 ? "not-allowed" : "pointer" }}
          >
            &lt; Prev
          </button>
          <span style={{ padding: "5px 15px" }}>Page {page}</span>
          <button
            disabled={Math.max(flightResults.length, hotelResults.length) <= page * RESULTS_PER_PAGE}
            onClick={() => setPage(p => p + 1)}
            style={{ padding: "5px 15px", borderRadius: 6 }}
          >
            Next &gt;
          </button>
        </div>

        {/* Results */}
        <div style={{ display: "flex", gap: 40, flexWrap: "wrap" }}>
          
          {/* Flights */}
          <div style={{ flex: 1, minWidth: 320 }}>
            <h2 style={{ fontSize: 24, fontWeight: 700, marginBottom: 15 }}>Flight Results</h2>
            {pagedFlights.length === 0 && <div style={{ padding: 20, background: "#f9f9f9", borderRadius: 8 }}>No flights found</div>}
            {pagedFlights.map(flight => (
              <div key={flight.id} style={{
                border: "1px solid #eee", margin: "12px 0", padding: "18px 15px", borderRadius: 9, background: "#fff"
              }}>
                <div style={{ fontSize: 18, fontWeight: 700, marginBottom: 8 }}>
                  {flight.airline} - {flight.flightNumber}
                </div>
                <div style={{ fontSize: 14, color: "#666", marginBottom: 4 }}>
                  {flight.origin} → {flight.destination}
                </div>
                <div style={{ fontSize: 14, color: "#666", marginBottom: 4 }}>
                  📅 {flight.departureDate} to {flight.returnDate}
                </div>
                <div style={{ fontSize: 14, color: "#666", marginBottom: 4 }}>
                  ⏰ Depart: {flight.departureTime} | Arrive: {flight.arrivalTime}
                </div>
                <div style={{ fontSize: 14, color: "#666", marginBottom: 10 }}>
                  {flight.stops === 0 ? "✈️ Direct" : `${flight.stops} stop(s)`}
                </div>
                <div style={{ fontSize: 22, fontWeight: 900, color: "#228468", marginBottom: 10 }}>
                  £{flight.price} <span style={{ fontSize: 14, fontWeight: 400, color: "#666" }}>per person</span>
                </div>
                <button onClick={() => handleWhatsApp('flight', flight)} style={{
                  padding: "10px 20px", background: "#25d366", color: "white", border: "none",
                  borderRadius: 8, fontSize: 14, fontWeight: 700, cursor: "pointer"
                }}>
                  📱 Book via WhatsApp
                </button>
              </div>
            ))}
          </div>

          {/* Hotels */}
          <div style={{ flex: 1, minWidth: 320 }}>
            <h2 style={{ fontSize: 24, fontWeight: 700, marginBottom: 15 }}>Hotel Results</h2>
            {pagedHotels.length === 0 && <div style={{ padding: 20, background: "#f9f9f9", borderRadius: 8 }}>No hotels found</div>}
            {pagedHotels.map(hotel => (
              <div key={hotel.id} style={{
                border: "1px solid #eee", margin: "12px 0", padding: "18px 15px", borderRadius: 9,
                display: "flex", alignItems: "flex-start", gap: 15, background: "#fff"
              }}>
                <img src={hotel.image} alt={hotel.name} style={{
                  width: 120, height: 90, objectFit: "cover", borderRadius: 8
                }} />
                <div style={{ flex: 1 }}>
                  <div style={{ fontSize: 18, fontWeight: 700, marginBottom: 5 }}>{hotel.name}</div>
                  <div style={{ fontSize: 14, color: "#666", marginBottom: 5 }}>
                    📍 {hotel.destination}
                  </div>
                  <div style={{ fontSize: 14, color: "#fec003", fontWeight: 700, marginBottom: 5 }}>
                    ⭐ {hotel.rating} ({hotel.reviews} reviews)
                  </div>
                  <div style={{ fontSize: 13, color: "#666", marginBottom: 8 }}>
                    {hotel.facilities.join(" • ")}
                  </div>
                  <div style={{ fontSize: 20, fontWeight: 900, color: "#228468", marginBottom: 10 }}>
                    £{hotel.pricePerNight} <span style={{ fontSize: 13, fontWeight: 400, color: "#666" }}>/ night</span>
                  </div>
                  <button onClick={() => handleWhatsApp('hotel', hotel)} style={{
                    padding: "8px 18px", background: "#25d366", color: "white", border: "none",
                    borderRadius: 8, fontSize: 14, fontWeight: 700, cursor: "pointer"
                  }}>
                    📱 Book via WhatsApp
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>

      </div>
      <Footer />
    </>
  );
}
